import {AdminAxios, AxiosFile} from "../../common/Axios";

const isInit = false;

const ACTION_URL = '/media/inventory';
const CONVERT_PUBLISH_URL = ACTION_URL + '/{inventoryId}/publish/{publishYn}';
const UPLOAD_AUDIO_FILE= ACTION_URL + '/audio/file'
const CONVERT_EXAMINATION_URL = ACTION_URL
    + '/{inventoryId}/examination/{examinationStatus}';
const BANNER_SIZE_URL = ACTION_URL + '/banner/size';
const CATEGORY_ONEDEPTH_URL = ACTION_URL + '/category';
const CATEGORY_ONEDEPTH_ALL_URL = ACTION_URL + '/category/all';
const CATEGORY_TWODEPTH_URL = ACTION_URL + '/category/{mediaCategory1}';
const INVENTORY_TYPE_URL = ACTION_URL + '/inventoryType';
const TARGETING_TYPE_URL = ACTION_URL + '/targetingType';

const SLASH = '/';

/**
 * 인벤토리 리스트 조회 api
 * @returns {Promise<null>}
 */
export async function selInventoryList(props) {
  let returnVal = null;
  if (isInit) {
    return [{
      publishYn: 'Y',
      siteName: 'imbc',
      username: 'imbc_master',
      inventoryName: 'iMBC 메인 오디오 지면',
      mediaUrl: '',
      deviceType: 'PC',
      category1: "",
      category2: "",
      description: '',
      agentTypes: [],
      id: 'imbc_master',
      productType: 'AUDIO',
      exposureInterval: '',
      bannerSize: '',
      feeCalculations: [
        {
          id: '',
          calculationEtc: '',
          calculationType: '',
          calculationValue: 0,
          contractStartDate: new Date(),
        }
      ],
      feeCalculation: {
        id: '',
        calculationEtc: '',
        calculationType: '',
        calculationValue: 0,
        contractStartDate: new Date(),
      },
      nonExposureConfigType: 'NONE',
      nonExposureConfigValue: '',
      allowTargetings: [],
      inventoryType: '',
      examinationStatus: "CONFIRMING"
    }, {
      publishYn: 'N',
      siteName: 'imbc',
      username: 'imbc_master',
      inventoryName: 'iMBC 섹션 오디오 지면',
      mediaUrl: '',
      deviceType: 'PC',
      category1: "",
      category2: "",
      description: '',
      agentTypes: [],
      id: 'imbc_master',
      productType: 'AUDIO',
      exposureInterval: '',
      bannerSize: '',
      feeCalculations: [
        {
          id: '',
          calculationEtc: '',
          calculationType: '',
          calculationValue: 0,
          contractStartDate: new Date(),
        }
      ],
      feeCalculation: {
        id: '',
        calculationEtc: '',
        calculationType: '',
        calculationValue: 0,
        contractStartDate: new Date(),
      },
      nonExposureConfigType: 'NONE',
      nonExposureConfigValue: '',
      allowTargetings: [],
      inventoryType: '',
      examinationStatus: "CONFIRMING"
    }]
  }
  const {deviceType, calculationType, searchKeywordType, keyword, categoryId} = props;

  let params = '';

  if (deviceType.value && deviceType.value !== 'ALL') {
    params += params !== '' ? '&' : '?';
    params += 'deviceType=' + deviceType.value;
  }
  if (calculationType.value && calculationType.value !== 'ALL') {
    params += params !== '' ? '&' : '?';
    params += 'calculationType=' + calculationType.label;
  }
  if (searchKeywordType.value && searchKeywordType.value !== 'ALL' && keyword) {
    params += params !== '' ? '&' : '?';
    params += 'searchKeywordType=' + searchKeywordType.value;
  }
  if (keyword) {
    params += params !== '' ? '&' : '?';
    params += 'keyword=' + encodeURIComponent(keyword);
  }
  if (categoryId !== null && categoryId !== undefined && categoryId !== '') {
    params += params !== '' ? '&' : '?';
    params += 'categoryId=' + encodeURIComponent(categoryId);
  }

  await AdminAxios('GET', ACTION_URL + params, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 인벤토리 상세 조회 api
 * @returns {Promise<null>}
 */
export async function selInventory(inventoryId) {
  let returnVal = null;
  if (isInit) {
    return {
      siteName: '',
      inventoryName: '',
      mediaUrl: '',
      deviceType: 'PC',
      category1: "",
      category2: "",
      description: '',
      agentTypes: [],
      id: '',
      productType: 'AUDIO',
      exposureInterval: '',
      bannerSize: '',
      feeCalculations: [
        {
          id: '',
          calculationEtc: '',
          calculationType: '',
          calculationValue: 0,
          contractStartDate: new Date(),
        }
      ],
      feeCalculation: {
        id: '',
        calculationEtc: '',
        calculationType: '',
        calculationValue: 0,
        contractStartDate: new Date(),
      },
      nonExposureConfigType: 'NONE',
      nonExposureConfigValue: '',
      allowTargetings: [],
      inventoryType: '',
      examinationStatus: "CONFIRMING"
    };
  }
  await AdminAxios('GET', ACTION_URL + SLASH + inventoryId, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 인벤토리 등록 api
 * @returns {Promise<null>}
 */
export async function createInventory(params) {
  let returnVal = null;
  let inventoryType = 'banner';
  switch (params.productType) {
    case'POP_UNDER' : inventoryType = 'cover'; break;
    case'AUDIO' : inventoryType = 'audio'; break;
    default : inventoryType = 'banner';
  }

  await AdminAxios('POST',
      ACTION_URL + SLASH + inventoryType, params)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 인벤토리 수정 api
 * @returns {Promise<null>}
 */
export async function updateInventory(inventoryId, params) {
  let returnVal = null;
  await AdminAxios('PUT', ACTION_URL + SLASH + inventoryId, params)
  .then((response) => {
    const { statusCode } = response;
    if(statusCode === 200){
      returnVal = statusCode;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/** 인벤토리 게재 여부 수정 api
 * @returns {Promise<null>}
 */
export async function convertInventoryPublishYn(inventoryId, publishYn) {
  let returnVal = null;
  let param = publishYn ? 'Y' : 'N';
  await AdminAxios('PUT',
      CONVERT_PUBLISH_URL.replace('{inventoryId}', inventoryId).replace(
          '{publishYn}', param),
      null)
  .then((response) => {
    const { statusCode } = response;
    if(statusCode === 200){
      returnVal = true;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/** 인벤토리 심사 상태 수정 api
 * @returns {Promise<null>}
 */
export async function convertInventoryExamination(inventoryId,
    examinationStatus) {
  let returnVal = null;
  await AdminAxios('PUT',
      CONVERT_EXAMINATION_URL.replace('{inventoryId}', inventoryId).replace(
          '{examinationStatus}', examinationStatus),
      null)
  .then((response) => {
    const { statusCode } = response;
    if(statusCode === 200){
      returnVal = statusCode;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/** 지면 사이즈 api
 * @returns {Promise<null>}
 */
export async function bannerSizeList() {
  let returnVal = null;
  if (isInit) {
    return [{key: "", value: ""}]
  }
  await AdminAxios('GET', BANNER_SIZE_URL, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/** 지면 카테고리 api
 * @returns {Promise<null>}
 */
export async function bannerCategoryOneDepthListAll() {
  let returnVal = null;
  if (isInit) {
    return [{key: "test", value: "test"}, {key: "test2", value: "test2"}];
  }
  await AdminAxios('GET', CATEGORY_ONEDEPTH_ALL_URL, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = null)
  return returnVal;
};
export async function bannerCategoryOneDepthList() {
  let returnVal = null;
  if (isInit) {
    return [{key: "test", value: "test"}, {key: "test2", value: "test2"}];
  }
  await AdminAxios('GET', CATEGORY_ONEDEPTH_URL, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = null)
  return returnVal;
};

/** 지면 카테고리 api
 * @returns {Promise<null>}
 */
export async function bannerCategoryTwoDepthList(mediaCategory1) {
  let returnVal = null;
  await AdminAxios('GET',
      CATEGORY_TWODEPTH_URL.replace('{mediaCategory1}', mediaCategory1.value),
      null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = null)
  return returnVal;
};

/** 지면 타입 api
 * @returns {Promise<null>}
 */
export async function inventoryTypeList() {
  let returnVal = null;
  if (isInit) {
    return [{key: "", value: ""}, {key: "", value: ""}];
  }
  await AdminAxios('GET', INVENTORY_TYPE_URL, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/** 타겟팅 타입 api
 * @returns {Promise<null>}
 */
export async function targetingTypeList() {
  let returnVal = null;
  if (isInit) {
    return [{key: "", value: ""}, {key: "", value: ""}];
  }
  await AdminAxios('GET', TARGETING_TYPE_URL, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function uploadAudioFile(asset) {
  let returnVal = null;
  const form = new FormData();
  form.append('file', asset, asset.name);

  await AxiosFile('POST', UPLOAD_AUDIO_FILE, form)
  .then(response => {
    const { data, statusCode } = response;
    if(statusCode === 200 ){
      returnVal = data;
    } else {
      returnVal = null;
    }
  })
  .catch((e) => returnVal = false)
  return returnVal;
};
